import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useCurrentUser } from 'my-core/hooks';

import { toggleLoginForm } from 'my-actions/AppStateActions';

export default function useLoginProtected() {
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();

  return useCallback(
    (callback, toggleStateProps) => {
      if (currentUser.guest) {
        dispatch(toggleLoginForm(toggleStateProps));
      } else {
        return callback();
      }
    },
    [currentUser.guest, dispatch],
  );
}
